<template>
  <div id="wish-list" class="wish-list">
    <surface-sections v-if="hasSections" />
    <div v-else-if="isBackchannel" id="wish-list-wrapper">
      <surface-post v-for="(post, index) in currentPosts"
                    :key="post.cid"
                    :index="index"
                    :post="post"
                    :edit="inlinePostEdit"
                    :is-last="index === (currentPosts.length - 1)"
                    @last-post-mounted="onLastPostMounted" />
      <div id="wish-list-bottom" :style="wishListBottomStyle" />
    </div>
    <template v-else>
      <surface-post v-for="(post, index) in currentPosts"
                  :key="post.cid"
                  :index="index"
                  :post="post"
                  :edit="inlinePostEdit"
                  :is-last="index === (currentPosts.length - 1)"
                  @last-post-mounted="onLastPostMounted" />
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import ConnectorsMixin from 'vuemixins/connectors_mixin'
import SortMixin from 'vuemixins/sort_mixin'
import PostPresentationMixin from 'vuemixins/post_presentation_mixin'
import SurfaceSections from 'vuecomponents/surface_sections'
import SurfacePost from 'vuecomponents/surface_post'
import { $ } from 'bits/jquery'
import { scrollToPost, scrollToSection, scrollNewPostIntoView } from 'surface/scroll_to_new_post'
import nativeBridge from 'bits/native_bridge'
import { listen as listenToApp } from 'native_bridge/listen'

export default {
  components: { SurfaceSections, SurfacePost },
  mixins: [
    ConnectorsMixin,
    SortMixin,
    PostPresentationMixin,
  ],
  data () {
    return {
      delayingUpdatePosts: false,
      currentPosts: [],
      wishListBottomStyle: {},
    }
  },
  computed: {
    ...mapState({
      inlinePostEdit: 'inlinePostEdit',
      backchannelListWrapperBottomPadding: 'editorHeight',
      isIPhoneX: 'isIPhoneX',
      isApp: 'isApp',
    }),
    ...mapGetters('section', { wallSections: 'sections' }),
    ...mapGetters('post', ['postCids', 'pendingPostCids', 'postEntitiesByCid', 'pendingPostEntitiesByCid', 'newestPostCid']),
    ...mapGetters({
      hasSections: 'isShelf',
      isBackchannel: 'isBackchannel',
      format: 'format',
      canIWrite: 'canIWrite',
      newPostLocation: 'newPostLocation',
    }),
  },
  watch: {
    backchannelListWrapperBottomPadding () {
      this.$nextTick(() => {
        this.updateWishListBottomMarginForBackchannel()
      })
    },
    sortedPosts (value) {
      // Must do this so that vue won't rerender and crash shapeshift
      // TODO: remove jquery and eventually shapeshift. (see GridMixin)
      const $draggingElement = $(this.$el).find('.ss-dragged-child')
      if (!$draggingElement[0]) {
        this.currentPosts = value
      }
    },
    newestPostCid (postCid) {
      if (this.format === 'free') {
        scrollToPost('#wall-container', this.postEntitiesByCid[postCid])
      } else if (this.format === 'shelf') {
        const sectionElement = document.getElementById(`section-${this.postEntitiesByCid[postCid].wall_section_id}`)
        scrollToSection(this.$el, sectionElement)
      } else if (this.format === 'stream' || this.format === 'grid' || this.format === 'matrix') {
        if (this.newPostLocation === 'bottom' && this.inlinePostEdit) {
          this.$nextTick(() => {
            scrollNewPostIntoView()
          })
        }
      }
    },
  },
  mounted () {
    this.currentPosts = this.sortedPosts
    if ((this.format === 'stream' || this.format === 'matrix') && this.canIWrite) {
      this.initializePostsSort()
    }
    this.$nextTick(() => {
      this.updateWishListBottomMarginForBackchannel()
    })
    nativeBridge.addMessageHandler('delete_comment', (msg) => {
      this.deleteComment({ commentId: msg.comment_id })
    })
    //nativeBridge.addMessageHandler('edit_comment', (msg) => {
    //  this.startEditingComment({ commentId: msg.comment_id })
    //})
    listenToApp('edit_comment', (msg) => {
      this.startEditingComment({ commentId: msg.comment_id })
    })

    nativeBridge.addMessageHandler('delete_section', (msg) => {
      this.deleteSection({ sectionId: msg.section_id })
    })

    nativeBridge.addMessageHandler('edit_section', (msg) => {
      this.startEditingSection({ sectionId: msg.section_id })
    })
  },
  methods: {
    ...mapActions(['announceWishListMounted']),
    ...mapActions('comment', ['deleteComment', 'startEditingComment']),
    ...mapActions('section', ['startEditingSection', 'deleteSection']),
    updateWishListBottomMarginForBackchannel () {
      let marginTop,
        marginBottom
      if (this.isIPhoneX && this.isApp) {
        marginTop = this.backchannelListWrapperBottomPadding - 34
        marginBottom = 34
      } else {
        marginTop = this.backchannelListWrapperBottomPadding
        marginBottom = 0
      }
      this.wishListBottomStyle = {
        marginTop: marginTop + 'px',
        marginBottom: marginBottom + 'px',
      }
    },
    onLastPostMounted () {
      this.announceWishListMounted()
    },
    onGridFinishDragging () {
      if (this.delayingUpdatePosts) {
        this.delayingUpdatePosts = false
        this.currentPosts = this.sortedPosts
      }
    },
  },

}
</script>
